var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.432 13.945c-.41.41-.43 1.143.01 1.573.43.43 1.162.42 1.572.01L7.99 9.54l5.987 5.986c.42.42 1.142.42 1.572-.01.42-.439.43-1.152 0-1.572L9.572 7.96l5.977-5.977a1.12 1.12 0 000-1.572c-.44-.42-1.152-.43-1.572-.01L7.99 6.387 2.014.4C1.604-.01.86-.03.44.41c-.43.43-.42 1.162-.01 1.572L6.419 7.96.432 13.945z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b9d0c48f0244a6606af11088ddff66c0.svg";
export { ForwardRef as ReactComponent };